// Takeout custom

// remove 'Total' attribute
document.addEventListener('takeout_before_checkout_submit', event => {
  if( event.form ) {
    let els = event.form.querySelectorAll('input[name="attributes[Total]"],input[name="attributes[Delivery Time]"]');
    for( let el of els ) el.remove();
  }
});
document.addEventListener('takeout_before_create_order', event => {
  if( event.formData ) {
    event.formData.delete('attributes[Total]');
    event.formData.delete('attributes[Delivery Time]');
  }
});

// prefill hidden field
document.addEventListener('takeout_builded', event => {
  let da = document.getElementById('takeout-input-delivery-address');
  let dp = document.getElementById('takeout-input-delivery-phone');
  if( da ) da.value = '-';
  if( dp ) dp.value = '1';
});

document.addEventListener('takeout_inited', event => {
  takeoutApp.getDeliveryDatepickerConfigNATIVE = takeoutApp.getDeliveryDatepickerConfig;
  takeoutApp.getDeliveryDatepickerConfig = function(aa) {
    let afteTomorrow = this.shop.time.getHours() >= 17;
    if( aa.length ) for( let a of aa ) { a.daysStatuses[0] = 0; if( afteTomorrow ) a.daysStatuses[1] = 0; }
    return takeoutApp.getDeliveryDatepickerConfigNATIVE(aa);
  }
});
// Takeout custom